const TopicTranslations = {
  "Overall": "全面的",
  "Critical Thinking": "批判性思維",
  "Logical Thinking": "邏輯思維",
  "Measurement & Space": "測量與空間",
  "Number & Algebra": "數與代數",
  "Statistics & Probability": "統計與機率",
  "Counting": "計數",
  "Act it out": "表演出來",
  "General Knowledge": "常識",
  "Speed": "速度",
  "Accuracy": "準確性",
  "Perseverance": "毅力",
};

Object.freeze(TopicTranslations);

export default TopicTranslations;
